import { generate as generateLoginWallTemplate, type Slots } from './LoginWall.preprocess';
import { appendElement } from '../../utils/appendElement';
import { AnalyticsOptions } from '../../utils/analytics';

export type { Slots as LoginWallSlots } from './LoginWall.preprocess';

const DEFAULT_SLOTS: Slots = {
  title: 'Dit artikel lezen?',
  content: 'Log in of maak een account om dit artikel gratis te lezen.',
  callToAction: 'Inloggen',
};

export function appendLoginWall(
  el: HTMLElement,
  {
    requiredLoginIdentityLevel,
    requiredRegisterIdentityLevel,
    brand,
    slots,
    onTrackEvent,
    options = {},
  }: {
    requiredLoginIdentityLevel?: string;
    requiredRegisterIdentityLevel?: string;
    brand: string;
    clientId: string;
    slots: Partial<Slots>;
    onTrackEvent: (event: Event) => void;
    options: Partial<AnalyticsOptions>;
  },
): Promise<void> {
  const searchParams = new URLSearchParams([
    ['register_identity_level', requiredRegisterIdentityLevel],
    ['login_identity_level', requiredLoginIdentityLevel],
    ['returnTo', window.location.href],
  ]);

  if (options['ext-internal']) {
    searchParams.append('ext-internal', options['ext-internal']);
  }
  if (options['ext-articleid']) {
    searchParams.append('ext-articleId', options['ext-articleid']);
  }
  if (options['ext-prsid']) {
    searchParams.append('ext-prsid', options['ext-prsid']);
  }
  if (options['ext-cid']) {
    searchParams.append('ext-cid', options['ext-cid']);
  }
  const template = generateLoginWallTemplate({
    searchParams: searchParams.toString(),
    title: slots.title ?? DEFAULT_SLOTS.title,
    content: slots.content ?? DEFAULT_SLOTS.content,
    callToAction: slots.callToAction ?? DEFAULT_SLOTS.callToAction,
  });

  const loginWall = document.createElement('div');
  loginWall.innerHTML = template.html;

  loginWall.querySelector('[data-login]')?.addEventListener('click', (e) => {
    onTrackEvent?.(e);
  });

  loginWall.querySelector('[data-register]')?.addEventListener('click', (e) => {
    onTrackEvent?.(e);
  });

  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      appendElement(el, loginWall, template.css);

      onTrackEvent?.(
        new CustomEvent('show', {
          detail: {
            target: loginWall,
          },
        }),
      );

      resolve();
    });
  });
}
